import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import MultiAppAuthentication from '../../components/MultiAppAuthentication';

const mapStateToProps = (state: StoreState) => {
	const { multiAppAuthenticationInfos, appInfos, galleryInfos: { config } } = state;
	const { accessibleApps, credentials, orgAuthMethods, form } = multiAppAuthenticationInfos;

	// userLocale is sent as a prop, to allow the rerendering of placeholders when the language is switched
	const { userLocale } = appInfos;
	// credentials.login are used in case of login failure if the user tries re-submitting without changing the form.login
	const login = credentials && credentials.login && !form.login ? credentials.login : form.login;

	return { accessibleApps, credentials, orgAuthMethods, login, userLocale, galleryConfig: config };
};

export default connect(mapStateToProps)(MultiAppAuthentication);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/index.tsx